import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import OtpInput from 'react-otp-input';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { navigate } from "hookrouter";
import { Alert, DConnect, DecryptData, getCookie, setCookie } from '../../components/Config';

function Introduction(props){

    const [isOTP, setOTP] = useState(false);
    const [isExist, setExist] = useState(false);
    const [login, setLogin] = useState({'idno':'', 'veri_option':'', 'bus_phone':'', 'otp': ''});
    const [registration, setRegistration] = useState(props.registration);

    useEffect(() => {
        if($('#bmenu').is(':visible')){ $('#bmenu').hide(); }
        if($('#smenu').is(':visible')){ $('#smenu').hide(); }

        setRegistration(props.registration);
    },[]);

    const handleChange = (e) => {
        e.preventDefault();

        const { name, value } = e.target;

        setLogin(prevState => ({
            ...prevState, [name]: value
        }));
    }

    const handleOTP = (otp) => {
        setLogin(prevState => ({
            ...prevState, ['otp']: otp
        })); 
    }

    const doNavigate = (pos) => {
        $(`ul.list-group li:nth-child(${pos})`).addClass('active');
        props.nextStep();
    }

    const checkExisting = async (reg) => {
        await DConnect().get(`financing?appnum=${reg.app_num}`).then(res => {
            let resdata = DecryptData(res.data);

            setExist(resdata.length > 0 && resdata[0].status>0);
        });
    }

    const submitForm = async (e) => {
        e.preventDefault();
        await DConnect().get(`registration/verifier3/${login.bus_phone}`).then(res => {
            let registration = DecryptData(res.data);
            setCookie('registration', JSON.stringify(registration));
            DConnect().get(`financing?appnum=${registration.app_num}`).then(res => {
                let resdata = DecryptData(res.data);
                
                if(resdata.length > 0 && resdata[0].status!==0){
                    setExist(true);
                    Alert({title:'Authentication',message:'You have applied already...', buttons:[{label:'Ok',onClick: () => window.location.reload()}]});
                }else{
                    setOTP(true);
                    setRegistration(registration);
                    props.handleChange(12, registration);
                }
            });  
        }).catch(error => {
            Alert({title:'Verification',message:'Wrong Business Phone...', buttons:[{label:'Ok'}]});
        });
    }

    const resendOTP = async () => {
        await DConnect().get(`registration/verifier2/${login.bus_phone}`).then(res => {
            let registration = DecryptData(res.data);
            setRegistration(registration);
        });
    }

    const submitForm2 = (e) => {
        e.preventDefault();
        if(login.veri_option == "2"){
           
        if(login.otp == registration.otp){
            setCookie('area', 1);
            window.location.reload();        
        }else{
            if(login.otp == ""){
                navigate("/application", true);
                window.location.reload();
            }else{
                Alert({title:'Verification',message:'You have entered an invalid OTP...', buttons:[{label:'Ok'}]});
            }
            setLogin(prevState => ({
                ...prevState, ['otp']: ""
            })); 
            
        }
      }else{
        DConnect().get(`registration/verify/${login.idno}/${login.bus_phone}`).then(res => {
            let registration = DecryptData(res.data);

            setCookie('registration', JSON.stringify(registration));
            DConnect().get(`financing?appnum=${registration.app_num}`).then(res => {
                let resdata = DecryptData(res.data);
                
                if(resdata.length > 0 && resdata[0].status!==0){
                    setExist(true);
                    Alert({title:'Authentication',message:'You have applied already...', buttons:[{label:'Ok',onClick: () => window.location.reload()}]});
                }else{
                    setRegistration(registration);
                    props.handleChange(12, registration);
                    setCookie('area', 1);
                    window.location.reload();
                }
            });  
        }).catch(error => {
            Alert({title:'Verification',message:'Wrong ID No...', buttons:[{label:'Ok',onClick: () => window.location.reload()}]});
        });
      }
    }

    return(
        <div className="content">
            <h5 className="pb-3">Initial <span>Authentication</span></h5>
            {!isOTP && <><form id="frmVerify" method="POST" onSubmit={submitForm}>
                <div className="row">
                   
                    <div className="col-xs-12 col-sm-6">
                         <div className="form-group">
                            <label className="control-label" for="bus_phone">Business Phone:</label><span className="required">*</span>
                            <input type="text" maxLength = "10" className="form-control" id="bus_phone" name="bus_phone" required="required" 
                                value={login.bus_phone} onChange={handleChange} />
                        </div>
                    </div>
                     <div className="col-xs-12 col-sm-6 ">
                        <div className="form-group">
                            <label className="control-label" for="veri_option">Select second verification option:</label><span className="required">*</span>
                            <select className="form-control custom-select" id="veri_option" name="veri_option" required="required"
                                value={login.veri_option} onChange={handleChange}>
                                <option value=""> -- Choose Option -- </option>
                                <option value="1">ID Number</option>
                                <option value="2">Your PIN</option>
                            </select>
                        </div>
                    </div>
                </div>
                
            </form>
            <button type="submit" form="frmVerify"  className="btn btn-bg btn-outline text-white p-3 mt-2" style={{borderRadius: '20px'}}><FontAwesomeIcon icon={faSignInAlt} size="sm" /> Login</button>
    </>} 
    {isOTP && login.veri_option == "2" && <form id="frmSubmit" method="POST" onSubmit={submitForm2}>
                <div className="row">
                    {/* <div className="col-xs-12 col-sm-6 ">
                        {!login && <div className="form-group">
                            <label className="control-label" for="idno">ID Number:</label><span className="required">*</span>
                            <input type="text" className="form-control" id="idno" name="idno" required="required" 
                                value={login.idno} onChange={handleChange} />
                        </div>}
                    </div> */}
                    <div className="col-md-12 col-sm-12 ">
                         <div className="form-group">
                         <label className="control-label" for="otp">Enter PIN<small> (sent via SMS/Email)</small>:</label><span className="required">*</span>
                             <OtpInput inputStyle={{width:'80px'}} value={login.otp} onChange={handleOTP} numInputs={4} separator={<span>-</span>}/>
                             <small><a className="tex-primary" onClick={resendOTP} style={{cursor: 'pointer'}}>Re-send PIN</a></small>
                        </div>
                    </div>
                </div>
                <button type="submit" form="frmSubmit" className="btn btn-bg btn-outline text-white p-3 mt-2" style={{borderRadius: '20px'}}><FontAwesomeIcon icon={faCheck} size="sm" /> Verify PIN</button>
            </form>}
            {isOTP && login.veri_option == "1" && <form id="frmSubmit" method="POST" onSubmit={submitForm2}>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 ">
                        <div className="form-group">
                            <label className="control-label" for="idno">ID Number:</label><span className="required">*</span>
                            <input type="text" className="form-control" id="idno" name="idno" required="required" 
                                value={login.idno} onChange={handleChange} />
                        </div>
                    </div>
                    
                </div>
                <button type="submit" form="frmSubmit" className="btn btn-bg btn-outline text-white p-3 mt-2" style={{borderRadius: '20px'}}><FontAwesomeIcon icon={faSignInAlt} size="sm" /> Login</button>
            </form>}        
            
            
        </div>
    );
}

export default Introduction;